import { Timestamp } from '@angular/fire/firestore';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

/**
 * Formats a date to a readable string. Eg. `Friday, 01 November`
 * @param date Date
 * @returns string
 */
export function formatDate(date: Date): string {
	const options: Intl.DateTimeFormatOptions = { weekday: 'long', day: 'numeric', month: 'long' };
	const formattedDate = date.toLocaleDateString('en-ZA', options);
	return formattedDate;
}

/**
 * Converts Date to NgbDateStruct
 * @param date Date
 * @returns NgbDateStruct
 */
export function dateToNgbDateStruct(date: Date): NgbDateStruct {
	const ngbDate: NgbDateStruct = {
		year: date.getFullYear(),
		month: date.getMonth() + 1,
		day: date.getDate(),
	};
	return ngbDate;
}

/**
 * Converts NgbDateStruct to Date.
 * @param ngbDate NgbDateStruct
 * @returns Date
 */
export function ngbDateStructToDate(ngbDate: NgbDateStruct): Date {
	const date = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
	return date;
}

/**
 * Formats Date Object to show current time
 * @param date
 * @returns time as a string
 */
export function getFormattedDateTime(date: Date): string {
	const hours = date.getHours().toString().padStart(2, '0');
	const minutes = date.getMinutes().toString().padStart(2, '0');
	const formattedTime = `${hours}:${minutes}`;
	return formattedTime;
}

export function convertTimestampToFormattedString(timestamp: Timestamp): string {
	const date = timestamp.toDate();
	return date
		.toLocaleString('en-GB', {
			day: 'numeric',
			month: 'long',
			hour: 'numeric',
			minute: '2-digit',
			hour12: true,
		})
		.replace(' at', ''); // Example: "16 March 12:29pm"
}
